// Helpers
import { to } from '../../../lib/helpers';

// Requests
import { userGetTodoItemsRequest } from '../../../backend/userRequests';

// Consts
export const USER_GET_TODO_ITEMS_SUCCESS_RECEIVED =
  '[USER] Get User Todo Items Success';

export const getTodoItems = () => async dispatch => {
  const [{ body, response }, err] = await to(
    dispatch(userGetTodoItemsRequest())
  );
  if (err) return Promise.reject(err);
  dispatch({ type: USER_GET_TODO_ITEMS_SUCCESS_RECEIVED, payload: body.data });
  return Promise.resolve({ body, response });
};
